import IApplicationVm from "./IApplicationVm"
import IMunicipalityVm from "./IMunicipalityVm"
import { ApplicationCardStatusType } from "./../enums/ApplicationCardStatusType"
import { FormerLicenseType } from "./../enums/FormerLicenseType"

import * as IApplicationVmInstance from "./IApplicationVm"
import * as IMunicipalityVmInstance from "./IMunicipalityVm"

export default interface IApplicationForTaxBasedOnExternalVm extends IApplicationVm {
    issuingMunicipality: IMunicipalityVm
    taxLicenseNumber: string
    licenseType: FormerLicenseType
    base64TaxLicenseFrontImage: string
    isTaxLicenseFrontImageModified: boolean
    base64TaxLicenseBackImage: string
    isTaxLicenseBackImageModified: boolean
    base64EducationalLicenseImage: string
    isEducationalLicenseImageModified: boolean
    formerLicenseCardStatus: ApplicationCardStatusType
}

export const empty = (enableIteration: boolean = true): IApplicationForTaxBasedOnExternalVm => {
	return {
		...IApplicationVmInstance.empty(),
		issuingMunicipality: IMunicipalityVmInstance.empty(),
		taxLicenseNumber: "",
		licenseType: FormerLicenseType.NotSet,
		base64TaxLicenseFrontImage: "",
		isTaxLicenseFrontImageModified: false,
		base64TaxLicenseBackImage: "",
		isTaxLicenseBackImageModified: false,
		base64EducationalLicenseImage: "",
		isEducationalLicenseImageModified: false,
		formerLicenseCardStatus: ApplicationCardStatusType.NotSet
	} as IApplicationForTaxBasedOnExternalVm
}